<template>
    <div class="advance">
     <img
      src="../assets/advance/banner.png"
      alt
      style="width: 100%; height: 13.125rem"
    />
    <h3 class="title01">学习提升</h3>

    <div style="margin-bottom:10.5625rem">
       <img
      src="../assets/advance/img01.png"
      alt
      style="vertical-align:top;width: 27.125rem; height: 18.125rem;margin-right:3.75rem ;"
    />
    <div style="width:33.5625rem;display: inline-block;margin-top: 4.0625rem; text-align: left;">
    <span>
        每一位新员工都有一位资深同事担任导师，带领新人熟悉公司环境并在工作上给予紧密的谘询与指导，帮助新人快速融入部门的环境与文化。
    </span>
    </div>
    </div>

  <div style="background-color:#F1F9FF;">
     <h3 class="title02">职业发展</h3>
     <span>公司建立了弹性的职业发展双通道，协助员工打造属于自己的发展规划。</span>
     <div> <img
      src="../assets/advance/img02.png"
      alt
      style="width: 57.8125rem; height: 30rem;margin-top: 3.5rem;margin-bottom: 3.0625rem;"
    /></div>
  </div>
 </div>
</template>


<style scoped>
.advance{
min-height: 100%;
}
.title01 {
  padding-top: 3.125rem;
  padding-bottom: 3.125rem;
}

.title02 {
  padding-top: 3.125rem;
  padding-bottom: 1.75rem;
}

h3{
  font-size: 1.5rem;
  line-height: 2.25rem;
  color: #1A1A1A;
}

span{
   color: #777777;
   font-size: .875rem;
   line-height:1.375rem;
}

</style>
<script>
import { onActivated } from 'vue';
export default {

    data () {
    return {
     msg: '学习发展'
    };
    },
    onActivated (){

    }
}
</script>



// WEBPACK FOOTER //
// src/components/Advance.vue